// Adding support to HTML Elements which are not supported by JUTRO

import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import PropTypes from 'prop-types';
import React from 'react';

const CustomHTMLElement = element => {
    const Component = element;

    const HTMLElement = props => {
        const { children } = props;
        return <Component {...props}>{children}</Component>;
    };

    HTMLElement.propTypes = {
        children: PropTypes.node,
    };

    HTMLElement.defaultProps = {
        children: null,
    };

    return HTMLElement;
};

const addHTMLElements = new Set(['ul', 'li', 'form', 'ol']);

const componentMap = {};
const components = {};

addHTMLElements.forEach(element => {
    // adding to componentMap
    componentMap[element] = { component: element };

    // adding to components
    components[element] = CustomHTMLElement(element);
});

setComponentMapOverrides(componentMap, components);
